/**
 * @generated SignedSource<<8d8296bdde7a062ba5a542bc4642fbca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRowWithFragments_issueEdge$data = {
  readonly node: {
    readonly __id: string;
    readonly issueId: string;
    readonly issueTypeField: {
      readonly issueType: {
        readonly hierarchy: {
          readonly level: number | null | undefined;
        } | null | undefined;
        readonly name?: string;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell_fields" | "IssueSummaryCell_issue" | "LinkRelationshipTypeCell_issueRef" | "RichTextCell_issue">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"FirstColumnCell" | "MergedCell">;
  readonly " $fragmentType": "IssueRowWithFragments_issueEdge";
};
export type IssueRowWithFragments_issueEdge$key = {
  readonly " $data"?: IssueRowWithFragments_issueEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRowWithFragments_issueEdge">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  },
  {
    "kind": "Variable",
    "name": "projectKeys",
    "variableName": "projectKeys"
  },
  {
    "kind": "Variable",
    "name": "shouldQueryHasChildren",
    "variableName": "shouldQueryHasChildren"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "isRemoteLinkedIssuesEnabled",
    "variableName": "isRemoteLinkedIssuesEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLinkRelationshipFieldEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRemoteLinkedIssuesEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRowWithFragments_issueEdge",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "FirstColumnCell"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": (v0/*: any*/),
          "kind": "FragmentSpread",
          "name": "MergedCell"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "issueId"
          },
          {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeHierarchyLevel",
                    "kind": "LinkedField",
                    "name": "hierarchy",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "level"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "IssueSummaryCell_issue"
          },
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "IssueKeyCell_fields"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isDensityFull",
                "variableName": "isDensityFull"
              }
            ],
            "kind": "FragmentSpread",
            "name": "RichTextCell_issue"
          },
          {
            "condition": "isLinkRelationshipFieldEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "LinkRelationshipTypeCell_issueRef"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    }
  ],
  "type": "JiraIssueEdge"
};
})();

(node as any).hash = "3bfecaefd0275dc7cffe81ed403403e2";

export default node;
